export default "__VITE_ASSET__C0odiC_8__"